import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { requestService } from 'src/core/services/api';
import { teamMembersRoutes } from './routes';
export class TeamMembers {
  constructor() {
    _defineProperty(this, "routes", teamMembersRoutes);
  }
  async getCompanyTeamMembers(data, options) {
    const resp = await requestService('property').get(this.routes.companyTeamMembers(data.companyId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async createNewTeamMember(data, options) {
    const resp = await requestService('property').post(this.routes.baseUrl, _objectSpread({}, data), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async disableTeamMember(data, options) {
    const resp = await requestService('property').post(this.routes.disable(data.teamMemberId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async enableTeamMember(data, options) {
    const resp = await requestService('property').post(this.routes.enable(data.teamMemberId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async deleteTeamMember(data, options) {
    const resp = await requestService('property').delete(this.routes.teamMemberId(data.teamMemberId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getCompanyTeamMembersAggregate(options) {
    const resp = await requestService('aggregate').get(this.routes.baseUrl, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
}